/*
This function works only in secure (https) sites. So this might not work locally.
In case there is need to use it locally mark the local url in `Insecure origins treated as secure` and it will work.

Chrome: chrome://flags/#unsafely-treat-insecure-origin-as-secure
*/

import { Toastr } from "components/Common/clearsense-ui/components";

const copyToClipboard = async (text, message) => {
  try {
    await navigator.clipboard.writeText(text);
    Toastr.success(message);
  } catch (error) {
    Toastr.error("Unable to copy to clipboard");
  }
};

export default copyToClipboard;
